var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3638 9.39387C25.0161 11.046 25.9612 13.276 25.999 15.6123C26.0369 17.9486 25.1647 20.208 23.5668 21.9129L23.3638 22.1229L19.1208 26.3649C18.5824 26.9029 17.8597 27.2162 17.099 27.2412C16.3382 27.2663 15.5964 27.0013 15.0238 26.4999L14.8798 26.3649L10.6358 22.1219C8.94797 20.434 7.99976 18.1448 7.99976 15.7579C7.99976 13.3709 8.94797 11.0817 10.6358 9.39387C12.3236 7.70603 14.6128 6.75781 16.9998 6.75781C19.3868 6.75781 21.676 7.70603 23.3638 9.39387ZM16.9998 12.7579C16.6058 12.7579 16.2157 12.8355 15.8518 12.9862C15.4878 13.137 15.1571 13.358 14.8785 13.6365C14.5999 13.9151 14.3789 14.2458 14.2282 14.6098C14.0774 14.9738 13.9998 15.3639 13.9998 15.7579C13.9998 16.1518 14.0774 16.5419 14.2282 16.9059C14.3789 17.2699 14.5999 17.6006 14.8785 17.8792C15.1571 18.1578 15.4878 18.3787 15.8518 18.5295C16.2157 18.6803 16.6058 18.7579 16.9998 18.7579C17.7955 18.7579 18.5585 18.4418 19.1211 17.8792C19.6837 17.3166 19.9998 16.5535 19.9998 15.7579C19.9998 14.9622 19.6837 14.1992 19.1211 13.6365C18.5585 13.0739 17.7955 12.7579 16.9998 12.7579Z",
    fill: "#FB8B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolPin);
export default __webpack_public_path__ + "static/media/school_pin.d9492c665682b2508682b6aaee514e74.svg";
export { ForwardRef as ReactComponent };